<template>
  <div class="community mb-3 p-2" v-if="isDisplay">
    <img src="@/core/assets/new-dashboard/gp-community.png" class="community_thumbnail mb-2" alt="">
    <div class="community_title mb-2 typo-title2 typo-medium text-lightmode">{{ $t('dashboard.community.desc') }}</div>
    <a 
      :href="communityUrl"
      target="_blank"
      class="community_action btn btn-light2 btn-sm btn-block"
      @click="onViewCommunity"
    >
      {{ $t('dashboard.community.action.title') }}
    </a>
</div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "Community",
  data() {
    return {
      isDisplay: false,  
      communityUrl: 'https://www.facebook.com/groups/gempages.community',
    }
  },
  computed: {
    ...mapState("account", {
      shopInfo: "shopInfo",
    }),
  },
  mounted() {
    this.isDisplay = !this.shopInfo.viewCommunity || this.shopInfo.viewCommunity !== "1";
  },
  methods: {
    ...mapActions("dashboard", {
      setViewCommunityMeta: "setViewCommunityMeta",
    }),
    onViewCommunity() {
      this.setViewCommunityMeta();
    }
  },
};
</script>

<style lang="scss" scoped>
  .community {
    border-radius: 3px;
    background-color: $neutral5;
    
    &_thumbnail {
      width: 100%;
      height: 100%;
      border-radius: 3px;
      display: block;
    }

    &_action {
      font-size: 12px !important;
      line-height: 18px !important;
    }

  }
</style>
